<template>
	<div>
		<div class="right" v-if="windowWidth>=800">
			<div class="ri_top" @click="upTop">
				<i class="el-icon-arrow-up"></i>
			</div>
			<div class="ri_text">
				<el-tooltip placement="left">
					<div slot="content">
						<div style="padding-bottom: 10px;width: 103px;">{{$t('right.weixin')}}</div>
						<el-image class="ri_tx_img" :src="aboutList.customer_service_public" fit="fill"></el-image>
					</div>
					<el-image class="ri_tx_img2" :src="require('@/assets/img/news/kf.png')" fit="fill"></el-image>
				</el-tooltip>
			</div>
			<div class="ri_text">
				<el-tooltip placement="left">
					<div slot="content" >
						<div style="padding-top: 10px;padding-bottom: 10px;">{{$t('right.salePhone')}}：</div>
						<div style="padding-top: 10px;padding-bottom: 10px;">{{aboutList.sales_tel}}</div>
					</div>
					<el-image class="ri_tx_img2" :src="require('@/assets/img/news/phone1.png')" fit="fill" @click="phoneChange(aboutList.sales_tel)"></el-image>
				</el-tooltip>
			</div>
			<div class="ri_text">
				<el-tooltip placement="left">
					<div slot="content" >
						<div>
							<div style="padding-bottom: 10px;width: 103px;">{{$t('right.opinion.text7')}}</div>
							<el-image class="ri_tx_img" :src="aboutList.wechat_code" fit="fill"></el-image>
						</div>
						<el-button  size="medium" type="danger" style="margin-top: 8px;"  @click="weixinChange(aboutList.sales_wechat)">{{$i18n.locale == 'en'?'Copy WeChat ID':'复制微信号'}}</el-button>
					</div>
					<el-image class="ri_tx_img2" :src="require('@/assets/img/news/weixin.png')" fit="fill"></el-image>
				</el-tooltip>
			</div>
			<div class="ri_text">
				<el-tooltip placement="left">
					<div slot="content">
						<div style="padding-bottom: 10px;width: 103px;">{{$t('right.opinion.text8')}}</div>
						<el-image class="ri_tx_img" :src="aboutList.wechat_public" fit="fill"></el-image>
					</div>
					<div slot="content" style="margin-top: 12px;">
						<div style="padding-bottom: 10px;width: 103px;">{{aboutList.product_title}}</div>
						<el-image class="ri_tx_img" :src="aboutList.product_public" fit="fill"></el-image>
					</div>
					<el-image class="ri_tx_img2" :src="require('@/assets/img/news/QRcode.png')" fit="fill" @click="weixinPublic('MzUxNDYyNTU0NA==')" ></el-image>
				</el-tooltip>
			</div>
			<div class="ri_text" @click="formShow = !formShow">
				<el-image class="ri_tx_img3" :src="require('@/assets/img/news/feedback.png')" fit="fill" ></el-image>	
			</div>	
			<div slot="content" style="position: fixed; right: 6rem;bottom: 9rem; background-color: #000;border-radius: 0.5rem;color: #fff;" v-if="formShow">
				<div style="width: 300px;margin: 10px;">
					<div style="padding-bottom: 10px;">{{$t('right.opinion.title')}}：</div>
				</div>
				<div style="width: 300px;margin: 10px;">
					<div style="padding-bottom: 10px;display: flex;">
						<div style="color: red;">*</div>{{$t('right.opinion.text1')}}
					</div>
					<div style="display: flex;">
						<el-input style="width: 200px;" :placeholder="$t('right.opinion.input1')" v-model="form.name" />
						<el-select style="width: 90px;margin-left: 10px;" v-model="form.sex" placeholder="请选择">
							<el-option v-for="item in options" :key="item.value" :label="item.value" :value="item.value">
							</el-option>
						</el-select>
					</div>
				</div>
							
				<div style="width: 300px;margin: 10px;">
					<div style="padding-bottom: 10px;display: flex;">
						<div style="color: red;">*</div>{{$t('right.opinion.text2')}}
					</div>
					<el-input :placeholder="$t('right.opinion.input2')" v-model="form.company" />
				</div>
							
				<div style="width: 300px;margin: 10px;">
					<div style="padding-bottom: 10px;display: flex;">
						<div style="color: red;">*</div>{{$t('right.opinion.text3')}}
					</div>
					<el-input :placeholder="$t('right.opinion.input3')" v-model="form.phone" />
				</div>
							
				<div style="width: 300px;margin: 10px;">
					<div style="padding-bottom: 10px;">{{$t('right.opinion.text6')}}</div>
					<el-input :placeholder="$t('right.opinion.input5')" v-model="form.email" />
				</div>
							
				<div style="width: 300px;margin: 10px;">
					<div style="padding-bottom: 10px;display: flex;">
						<div style="color: red;">*</div>{{$t('right.opinion.text4')}}
					</div>
					<el-input  type="textarea" :autosize="{ minRows: 2, maxRows: 4}" :placeholder="$t('right.opinion.input4')" v-model="form.content"></el-input>
				</div>
							
				<div style="width: 300px;margin: 20px 10px 10px 10px;">
					<el-button
					  :loading="loading"
					  size="medium"
					  type="danger"
					  style="width:100%;"
					  @click.native.prevent="sendComments">
					  <span v-if="!loading">{{$t('right.opinion.text5')}}</span>
					  <span v-else>{{$t('right.opinion.text9')}}...</span>
					</el-button>
				</div>
			</div>
			<div class="ri_bottom" @click="down">
				<i class="el-icon-arrow-down"></i>
			</div>
		</div>
		
		<div class="right" v-if="windowWidth<=799">
			<div class="ri_top" @click="upTop" v-if="show">
				<i class="el-icon-arrow-up"></i>
			</div>
			
			<div class="ri_text" v-if="show">
				<el-tooltip placement="left">
					<div slot="content">
						<div style="padding-bottom: 10px;width: 103px;">{{$t('right.weixin')}}</div>
						<el-image class="ri_tx_img" :src="aboutList.customer_service_public" fit="fill"></el-image>
					</div>
					<el-image class="ri_tx_img2" :src="require('@/assets/img/news/kf.png')" fit="fill"></el-image>
				</el-tooltip>
			</div>
			<div class="ri_text" v-if="show">
				<el-tooltip placement="left">
					<div slot="content" >
						<div style="padding-top: 10px;padding-bottom: 10px;">{{$t('right.salePhone')}}：</div>
						<div style="padding-top: 10px;padding-bottom: 10px;">{{aboutList.sales_tel}}</div>
					</div>
					<el-image class="ri_tx_img2" :src="require('@/assets/img/news/phone1.png')" fit="fill" @click="phoneChange(aboutList.sales_tel)"></el-image>
				</el-tooltip>
			</div>
			<div class="ri_text" v-if="show">
				<el-tooltip placement="left">
					<div slot="content" >
						<div>
							<div style="padding-bottom: 10px;width: 103px;">{{$t('right.opinion.text7')}}</div>
							<el-image class="ri_tx_img" :src="aboutList.wechat_code" fit="fill"></el-image>
						</div>
						<el-button  size="medium" type="danger" style="margin-top: 8px;"  @click="weixinChange(aboutList.sales_wechat)">{{$i18n.locale == 'en'?'Copy WeChat ID':'复制微信号'}}</el-button>
					</div>
					<el-image class="ri_tx_img2" :src="require('@/assets/img/news/weixin.png')" fit="fill" ></el-image>
				</el-tooltip>
			</div>
			<div class="ri_text" v-if="show">
				<el-tooltip placement="left">
					<div slot="content">
						<div style="padding-bottom: 10px;width: 103px;">{{$t('right.opinion.text8')}}</div>
						<el-image class="ri_tx_img" :src="aboutList.wechat_public" fit="fill"></el-image>
					</div>
					<div slot="content" style="margin-top: 12px;">
						<div style="padding-bottom: 10px;width: 103px;">{{aboutList.product_title}}</div>
						<el-image class="ri_tx_img" :src="aboutList.product_public" fit="fill"></el-image>
					</div>
					<el-image class="ri_tx_img2" :src="require('@/assets/img/news/QRcode.png')" fit="fill" @click="weixinPublic('MzUxNDYyNTU0NA==')" ></el-image>
				</el-tooltip>
			</div>
			<div class="ri_text" v-if="show" @click="formShow = !formShow">
				<el-image class="ri_tx_img3" :src="require('@/assets/img/news/feedback.png')" fit="fill"></el-image>
			</div>
			
			<div slot="content" style="position: fixed; right: 5rem;bottom: 1rem; background-color: #000;border-radius: 0.5rem;color: #fff;" v-if="formShow">
				<div style="width: 300px;margin: 10px;">
					<div style="padding-bottom: 10px;">{{$t('right.opinion.title')}}：</div>
				</div>
				<div style="width: 300px;margin: 10px;">
					<div style="padding-bottom: 10px;display: flex;">
						<div style="color: red;">*</div>{{$t('right.opinion.text1')}}
					</div>
					<div style="display: flex;">
						<el-input style="width: 200px;" :placeholder="$t('right.opinion.input1')" v-model="form.name" />
						<el-select style="width: 90px;margin-left: 10px;" v-model="form.sex" placeholder="请选择">
							<el-option v-for="item in options" :key="item.value" :label="item.value" :value="item.value">
							</el-option>
						</el-select>
					</div>
				</div>
					
				<div style="width: 300px;margin: 10px;">
					<div style="padding-bottom: 10px;display: flex;">
						<div style="color: red;">*</div>{{$t('right.opinion.text2')}}
					</div>
					<el-input :placeholder="$t('right.opinion.input2')" v-model="form.company" />
				</div>
					
				<div style="width: 300px;margin: 10px;">
					<div style="padding-bottom: 10px;display: flex;">
						<div style="color: red;">*</div>{{$t('right.opinion.text3')}}
					</div>
					<el-input :placeholder="$t('right.opinion.input3')" v-model="form.phone" />
				</div>
					
				<div style="width: 300px;margin: 10px;">
					<div style="padding-bottom: 10px;">{{$t('right.opinion.text6')}}</div>
					<el-input :placeholder="$t('right.opinion.input5')" v-model="form.email" />
				</div>
					
				<div style="width: 300px;margin: 10px;">
					<div style="padding-bottom: 10px;display: flex;">
						<div style="color: red;">*</div>{{$t('right.opinion.text4')}}
					</div>
					<el-input  type="textarea" :autosize="{ minRows: 2, maxRows: 4}" :placeholder="$t('right.opinion.input4')" v-model="form.content"></el-input>
				</div>
					
				<div style="width: 300px;margin: 20px 10px 10px 10px;">
					<el-button
					  :loading="loading"
					  size="medium"
					  type="danger"
					  style="width:100%;"
					  @click.native.prevent="sendComments">
					  <span v-if="!loading">{{$t('right.opinion.text5')}}</span>
					  <span v-else>{{$t('right.opinion.text9')}}...</span>
					</el-button>
				</div>
			</div>
			
			<div class="ri_bottom" @click="down" v-if="show">
				<i class="el-icon-arrow-down"></i>
			</div>
			
			<div class="ri_show"  @click="refresh()">
				<i class="el-icon-refresh" style="font-size:1.5rem;color: #fff"></i>
			</div>
			
			<div class="ri_show"  @click="$router.go(-1)">
				<i class="el-icon-back" style="font-size:1.5rem;color: #fff"></i>
			</div>
			
			<div class="ri_show"  @click="iconShow">
				<i :class="show ?'el-icon-s-help':'el-icon-help'" :style="show?'color: red;':'color: #fff;'" style="font-size:1.5rem;"></i>
			</div>
			
		</div>
		
	</div>
</template>

<script>
	import * as feedbackApi from "@/api/home/feedback.js"
	import * as aboutApi from "@/api/home/about.js"
	import CButton from '@/components/CButton/index.vue'
	import {
		scrollTo
	} from '@/utils/scroll-to'
	export default {
		components: {
			CButton
		},
		data() {
			return {
				show:false,
				formShow:false,//弹窗
				form: {
					name: null, //姓名
					sex:'先生',//性别
					company: null, //公司名称
					phone: null, //电话号码
					email: null, //邮箱
					content: null, //留言
				},
				options: [{
					value: '先生',
				}, {
					value: '女士',
				}],
				loading: false,
				aboutList:{},//企业信息
			}
		},
		props: {
			//宽
			windowWidth: {
				type: Number,
				default: 0
			},
		},
		created() {
			if(this.$i18n.locale == 'cn'){
				this.form.sex = '先生'
				this.options = [{value: '先生'}, {value: '女士'}]
			}else{
				this.form.sex = 'Mr.'
				this.options = [{value: 'Mr.'}, {value: 'Ms.'}]
			}
			this.getAbout()
		},

		watch: {
			'$i18n.locale'(val) {
				if(val == 'cn'){
					this.form.sex = '先生'
					this.options = [{value: '先生'}, {value: '女士'}]
				}else{
					this.form.sex = 'Mr.'
					this.options = [{value: 'Mr.'}, {value: 'Ms.'}]
				}
				this.getAbout()
			}
		},

		computed: {

		},

		methods: {
			iconShow(){
				this.show = !this.show
			},
			
			//获取企业信息
			getAbout(){
				aboutApi.queryList({language:this.$i18n.locale == 'en'?'English':'中文'}).then(res=>{
					// console.log('关于企业信息2',res)
					if(res.code == 200 && res.rows.length>0){
					  let data = res.rows[0]
					  data.wechat_code = this.HttpChange('URL',data.wechat_code)
					  data.wechat_public = this.HttpChange('URL',data.wechat_public)
					  data.product_public = this.HttpChange('URL',data.product_public)
					  data.customer_service_public = this.HttpChange('URL',data.customer_service_public)
					  this.aboutList = data
					}
				})
			},
			
			upTop: function() {
				scrollTo(0, 800)
			},

			down: function() {
				scrollTo(document.body.scrollHeight, 800)
			},

			sendComments: function() {
				this.loading=true
				if(this.form.name==null){
					this.$message.error("请输入姓名")
					this.loading=false
				}else if(this.form.phone==null){
					this.$message.error("请输入电话号码")
					this.loading=false
				}else if (!(/^1[3456789]\d{9}$/.test(this.form.phone))) {
					this.$message.error("请输入正确的电话号码")
					this.loading=false
				}else if(this.form.company==null){
					this.$message.error("请输入公司")
					this.loading=false
				}else if(this.form.content==null){
					this.$message.error("请输入留言")
					this.loading=false
				}else{
					this.form.language = this.$i18n.locale == 'en'?'English':'中文'
					feedbackApi.addList(this.form).then(res=>{
						if (res.code == 200) {
							this.open=false
							this.loading=false
							this.reset()
							this.$alert(this.$i18n.locale == 'en'?'We have received your opinions. Our staff will contact you. Thank you sincerely for your feedback!':'您的意见我们已经收到，我们的工作人员会与您联系，衷心谢谢您的反馈！', this.$i18n.locale == 'en'?'feedback':'意见反馈', {
							        confirmButtonText: this.$i18n.locale == 'en'?'sure':'确定',
							});
						}else{
							this.loading=false
							this.$message.error('反馈意见发送失败！');
						}
					})
				}
			},
			
			reset(){
				this.form ={
					name: null, //姓名
					sex:'先生',//性别
					company: null, //公司名称
					phone: null, //电话号码
					email: null, //邮箱
					content: null, //留言
				}
			},
			
			phoneChange(e){
				if(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad Pro|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows phone)/i)){
					window.location.href = 'tel://'+e
				}
			},
			 
			weixinChange(e){
				if(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad Pro|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows phone)/i)){
					let info = document.createElement('input')
					info.value = e
					document.body.appendChild(info)
					info.select()
					document.execCommand("Copy")
					alert('您已成功复制销售微信号，请前往微信添加！')
					window.location.href = 'weixin://'
				}else{
					let info = document.createElement('input')
					info.value = e
					document.body.appendChild(info)
					info.select()
					document.execCommand("Copy")
					alert('您已成功复制销售微信号，请前往微信添加！')
				}
			},
			
			weixinPublic(e){
				// if(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad Pro|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows phone)/i)){
				// 	window.location.href = ' https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz='+e
				// }
			},
			
			refresh(){
				window.location.reload()
			}
		}
	}
</script>

<style lang="less" scoped>
	.el-icon-arrow-down {
		color: #fff;
		font-size: 20px;
	}

	.el-icon-arrow-up {
		color: #fff;
		font-size: 20px;
	}

	@media only screen and (min-width:1920px) {
		.right {
			position: fixed;
			bottom: 150px;
			right: 0;
			z-index: 999;

			.ri_top {
				background: #000;
				opacity: .9;
				border-top-left-radius: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 20px;
				cursor: pointer;

				.ri_to_icon {
					color: #fff;
					font-size: 24px;
				}
			}

			.ri_text {
				background: #000;
				opacity: .9;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 20px;
				cursor: pointer;

				.ri_qq {
					color: #fff;
					padding: 10px;
					width: 150px;
				}

				.ri_tx_img2 {
					width: 40px;
					height: 40px;
				}

				.ri_tx_img3 {
					width: 35px;
					height: 35px;
				}

				.ri_icon {
					color: #fff;
					font-size: 24px;
				}
			}

			.ri_bottom {
				background: #000;
				opacity: .9;
				border-bottom-left-radius: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 20px;
				cursor: pointer;

				.ri_bo_down {
					color: #fff;
					font-size: 24px;
				}
			}

			.ri_top:hover {
				opacity: .8;
			}

			.ri_text:hover {
				opacity: .8;
			}

			.ri_bottom:hover {
				opacity: .8;
			}

		}

		.ri_tx_img {
			width: 100px;
			height: 100px;
		}
	}

	@media only screen and (max-width:1920px) {
		.right {
			position: fixed;
			bottom: 150px;
			right: 0;
			z-index: 999;

			.ri_top {
				background: #000;
				opacity: .9;
				border-top-left-radius: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 20px;
				cursor: pointer;

				.ri_to_icon {
					color: #fff;
					font-size: 24px;
				}
			}

			.ri_text {
				background: #000;
				opacity: .9;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 20px;
				cursor: pointer;

				.ri_qq {
					color: #fff;
					padding: 10px;
					width: 150px;
				}

				.ri_tx_img2 {
					width: 40px;
					height: 40px;
				}

				.ri_tx_img3 {
					width: 35px;
					height: 35px;
				}

				.ri_icon {
					color: #fff;
					font-size: 24px;
				}
			}

			.ri_bottom {
				background: #000;
				opacity: .9;
				border-bottom-left-radius: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 20px;
				cursor: pointer;

				.ri_bo_down {
					color: #fff;
					font-size: 24px;
				}
			}

			.ri_top:hover {
				opacity: .8;
			}

			.ri_text:hover {
				opacity: .8;
			}

			.ri_bottom:hover {
				opacity: .8;
			}

		}

		.ri_tx_img {
			width: 100px;
			height: 100px;
		}
	}

	@media only screen and (max-width:1919px) and (min-width:1440px) {
		.right {
			position: fixed;
			bottom: 150px;
			right: 0;
			z-index: 999;

			.ri_top {
				background: #000;
				opacity: .9;
				border-top-left-radius: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 20px;
				cursor: pointer;

				.ri_to_icon {
					color: #fff;
					font-size: 24px;
				}
			}

			.ri_text {
				background: #000;
				opacity: .9;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 20px;
				cursor: pointer;

				.ri_qq {
					color: #fff;
					padding: 10px;
					width: 150px;
				}

				.ri_tx_img2 {
					width: 40px;
					height: 40px;
				}

				.ri_tx_img3 {
					width: 35px;
					height: 35px;
				}

				.ri_icon {
					color: #fff;
					font-size: 24px;
				}
			}

			.ri_bottom {
				background: #000;
				opacity: .9;
				border-bottom-left-radius: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 20px;
				cursor: pointer;

				.ri_bo_down {
					color: #fff;
					font-size: 24px;
				}
			}

			.ri_top:hover {
				opacity: .8;
			}

			.ri_text:hover {
				opacity: .8;
			}

			.ri_bottom:hover {
				opacity: .8;
			}

		}

		.ri_tx_img {
			width: 100px;
			height: 100px;
		}
	}

	@media only screen and (max-width:1439px) and (min-width:1200px) {
		.right {
			position: fixed;
			bottom: 150px;
			right: 0;
			z-index: 999;

			.ri_top {
				background: #000;
				opacity: .9;
				border-top-left-radius: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 20px;
				cursor: pointer;

				.ri_to_icon {
					color: #fff;
					font-size: 16px;
				}
			}

			.ri_text {
				background: #000;
				opacity: .9;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 20px;
				cursor: pointer;

				.ri_qq {
					color: #fff;
					padding: 10px;
					width: 150px;
				}

				.ri_tx_img2 {
					width: 30px;
					height: 30px;
				}

				.ri_tx_img3 {
					width: 25px;
					height: 25px;
				}

				.ri_icon {
					color: #fff;
					font-size: 16px;
				}
			}

			.ri_bottom {
				background: #000;
				opacity: .9;
				border-bottom-left-radius: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 20px;
				cursor: pointer;

				.ri_bo_down {
					color: #fff;
					font-size: 16px;
				}
			}

			.ri_top:hover {
				opacity: .8;
			}

			.ri_text:hover {
				opacity: .8;
			}

			.ri_bottom:hover {
				opacity: .8;
			}

		}

		.ri_tx_img {
			width: 100px;
			height: 100px;
		}
	}

	@media only screen and (max-width:1199px) and (min-width:800px) {
		.right {
			position: fixed;
			bottom: 150px;
			right: 0;
			z-index: 999;

			.ri_top {
				background: #000;
				opacity: .9;
				border-top-left-radius: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 20px;
				cursor: pointer;

				.ri_to_icon {
					color: #fff;
					font-size: 16px;
				}
			}

			.ri_text {
				background: #000;
				opacity: .9;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 20px;
				cursor: pointer;

				.ri_qq {
					color: #fff;
					padding: 10px;
					width: 150px;
				}

				.ri_tx_img2 {
					width: 30px;
					height: 30px;
				}

				.ri_tx_img3 {
					width: 25px;
					height: 25px;
				}

				.ri_icon {
					color: #fff;
					font-size: 16px;
				}
			}

			.ri_bottom {
				background: #000;
				opacity: .9;
				border-bottom-left-radius: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 20px;
				cursor: pointer;

				.ri_bo_down {
					color: #fff;
					font-size: 16px;
				}
			}

			.ri_top:hover {
				opacity: .8;
			}

			.ri_text:hover {
				opacity: .8;
			}

			.ri_bottom:hover {
				opacity: .8;
			}

		}

		.ri_tx_img {
			width: 100px;
			height: 100px;
		}
	}

	@media only screen and (max-width:799.9px) {
		.right {
			position: fixed;
			bottom: 0px;
			// right: 0;
			z-index: 999;

			.ri_top {
				background: #000;
				opacity: .9;
				border-top-left-radius: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 20px;
				cursor: pointer;

				.ri_to_icon {
					color: #fff;
					font-size: 12px;
				}
			}

			.ri_text {
				background: #000;
				opacity: .9;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 20px;
				cursor: pointer;

				.ri_qq {
					color: #fff;
					padding: 10px;
					width: 100px;
				}

				.ri_tx_img2 {
					width: 20px;
					height: 20px;
				}

				.ri_tx_img3 {
					width: 20px;
					height: 20px;
				}

				.ri_icon {
					color: #fff;
					font-size: 12px;
				}
			}

			.ri_bottom {
				background: #000;
				opacity: .9;
				border-bottom-left-radius: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 20px;
				cursor: pointer;
				.ri_bo_down {
					color: #fff;
					font-size: 12px;
				}
			}
			
			.ri_show {
				background: #000;
				opacity: .9;
				border-radius: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 20px;
				cursor: pointer;
				margin-top: 8px;
			}

			.ri_top:hover {
				opacity: .8;
			}

			.ri_text:hover {
				opacity: .8;
			}

			.ri_bottom:hover {
				opacity: .8;
			}

		}

		.ri_tx_img {
			width: 100px;
			height: 100px;
		}
	}
</style>